import { wrap } from '@popmotion/popcorn';
import { css } from '@emotion/react';
import React from 'react';
import { useSliderContext } from './index';
import { breakpoints } from '../tokens';
import { colors } from '../colors';
import ArrowIcon from '../../../images/svg/arrow.svg';
import PointIcon from '../../../images/svg/nav-point.svg';

const buttonStyles = css({
    display: 'flex',
    [breakpoints.tb]: {
        display: 'none',
    },
    position: 'relative',
    width: '35px',
    height: '35px',
    alignItems: 'center',
    justifyContent: 'center',
    '&:disabled': { cursor: 'default', opacity: 0.5 },
    svg: { position: 'relative', zIndex: 1, width: '13px', height: '13px' },
    '&::after': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        display: 'block',
        width: '25px',
        height: '25px',
        backgroundColor: colors.primaryOrange,
        borderRadius: '30px',
        transform: 'translate(-50%, -50%)',
        content: "''",
        transition: '0.3s',
    },
    '&:active:after': {
        backgroundColor: colors.primaryOrangeHover,
    },
});

const Pagination = ({ slidesLength, small, className }: { slidesLength: number, small?: boolean, className?: string }): JSX.Element => {
    const { paginate, page, jumpTo } = useSliderContext();
    const slideIndex = wrap(0, slidesLength, page);

    return (
        <div
            css={{
                position: 'relative',
                zIndex: 4,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            className={className}
        >
            {!small && (
                <button
                    type="button"
                    aria-label="Jump to previous slide"
                    css={buttonStyles}
                    onClick={() => paginate(-1)}
                >
                    <ArrowIcon css={{
                        fill: colors.shadesWhite,
                    }}
                    />
                </button>
            )}
            <div css={{
                display: 'flex',
                padding: small ? '0' : '32px 24px',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            >
                {[...Array(slidesLength)].map((_, index) => (
                    <button
                        key={`slide-${index + 1}`}
                        type="button"
                        aria-label={`View slide ${index + 1}`}
                        css={{
                            cursor: 'pointer',
                            padding: '5px',
                            listStyle: 'none',
                            svg: {
                                transition: '0.3s',
                                fill: slideIndex === index ? colors.primaryOrange : colors.grey300,
                                opacity: slideIndex === index ? 1 : 0.3,
                            },
                            '&:active svg': {
                                fill: colors.primaryOrangeHover,
                                opacity: 1,
                            },
                        }}
                        onClick={() => jumpTo(index)}
                    >
                        <PointIcon />
                    </button>
                ))}
            </div>
            {!small && (
                <button
                    type="button"
                    aria-label="Jump to previous slide"
                    css={buttonStyles}
                    onClick={() => paginate(1)}
                >
                    <ArrowIcon css={{
                        fill: colors.shadesWhite,
                        transform: 'rotate(180deg)',
                    }}
                    />
                </button>
            )}
        </div>
    );
};

export default Pagination;
